import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT = {
  hero_title: "Benvenuti nello Shop ufficiale di ButiStock!",
  hero_subtitle: "Vendiamo stock e fallimenti ai migliori prezzi sul mercato.",
  hero_image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=1400",
  marquee_items: ["VENDITA STOCK E FALLIMENTI", "SCONTI FINO AL 70%"],
  nav_categories: [],
  contact_nav: { label: "Dove siamo", position: 1 },
  home_categories: [],
  used_market: { enabled: false, title: "Mercatino dell'usato", subtitle: "", hero_image: "" },
  whatsapp_number: "39", pickup_address: "", reservation_notice: "La richiesta non costituisce conferma. Attendi la conferma via WhatsApp prima del ritiro.",
};

const Ctx = createContext({ config: DEFAULT, refresh: () => {} });

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT);
  const [loaded, setLoaded] = useState(false);
  const refresh = () => api.get("/site-config")
    .then((r) => setConfig(r.data))
    .catch(() => {})
    .finally(() => setLoaded(true));
  useEffect(() => { refresh(); }, []);
  return <Ctx.Provider value={{ config, loaded, refresh }}>{children}</Ctx.Provider>;
}

export const useSiteConfig = () => useContext(Ctx);
